import React, { useEffect, useRef, useState } from "react";
import { Grid } from "@mui/material";
import Routes from "routes/Routes";
import { Header } from "components/core/Header";
import "./Layout.scss";
import { useLocation } from "react-router-dom";
import { GlobalMessage } from "../GlobalMessage";
import { NewHeader } from "components/core/Header/NewHeader";
import { Notification } from "components/Notification";

export function Layout() {
  const routePath = useLocation();
  const refContainer = useRef<any>();
  const [isNewHomePage, setIsNewHomePage] = useState(false);
  const [isTargetPage, setIsTargetPage] = useState(false);
  const [isPrivacyPage, setIsPrivacyPage] = useState(false);

  useEffect(() => {
    if (refContainer.current) {
      refContainer.current.scrollTop = 0;
    }
    if (routePath && routePath.pathname && routePath.pathname === "/privacy") {
      setIsPrivacyPage(true);
    }
    if (
      routePath &&
      routePath.pathname &&
      (routePath.pathname === "/targetPage/" ||
        routePath.pathname === "/targetAppDashboard/")
    ) {
      setIsTargetPage(true);
      setIsPrivacyPage(false);
    } else if (
      routePath &&
      routePath.pathname &&
      routePath.pathname === "/home"
    ) {
      setIsNewHomePage(true);
      setIsPrivacyPage(false);
    } else if (
      routePath &&
      routePath.pathname &&
      routePath.pathname.includes("/appsInfo/")
    ) {
      setIsNewHomePage(true);
      setIsPrivacyPage(false);
    } else {
      setIsNewHomePage(false);
    }
  }, [routePath]);
  const globalErr = process.env.REACT_APP_GLOBAL_ERR_MSG;

  return (
    <>
      {isTargetPage && !isNewHomePage && (
        <div>
          <Notification />
          <Routes />
        </div>
      )}
      {!isNewHomePage && !isTargetPage && !isPrivacyPage && (
        <Grid container className="layout-container">
          <Grid item xs={12} className="header-container">
            <Header />
          </Grid>

          <Grid
            item
            md={12}
            xs={12}
            className="right-container custom-scroll"
            ref={refContainer}
          >
            {globalErr && <GlobalMessage></GlobalMessage>}

            <Grid container>
              <Grid
                item
                container
                xs={12}
                justifyContent="center"
                className="page-container"
              >
                <Grid item md={12} lg={12} xl={12} xs={12}>
                  <Routes />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
      {isNewHomePage && !isTargetPage && !isPrivacyPage && (
        <>
          <div className="header-container-new">
            <NewHeader />
          </div>
          <div className="apps-container-iframe">
            <Routes />
          </div>
        </>
      )}
      {isPrivacyPage && (
        <Grid container className="layout-container">
          <Grid item xs={12} className="header-container">
            <NewHeader />
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
            className="right-container custom-scroll"
            ref={refContainer}
          >
            {globalErr && <GlobalMessage></GlobalMessage>}

            <Grid container>
              <Grid
                item
                container
                xs={12}
                justifyContent="center"
                className="page-container"
              >
                <Grid item md={12} lg={12} xl={12} xs={12}>
                  <Routes />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
}
